const getters = {
  token: state => state.user.token,
  userCode: state => state.user.userCode,
  userName: state => state.user.name,
  idCard: state => state.user.idCard,
  dept: state => state.user.dept,
  deptcode: state => state.user.deptcode,
  questionBanks: state => state.exam.questionBanks,
  questionTags: state => state.exam.questionTags
}
export default getters 
